import { Platform } from '@/types/platform'

const ALLOWED_GOODS_WIDGET_PLATFORMS = [
  Platform.cosmo,
  Platform.goodhouse,
  Platform.esquire,
  Platform.mhealth,
  Platform.popmech,
]

export { ALLOWED_GOODS_WIDGET_PLATFORMS }
